import * as types from "@/constants"
import api from "@/api"
import { mediaSDK, signalSdk } from "@/utils/getSDK"
import {
  onlineClassId,
  roomId,
  userId,
  userRole,
  lessonId,
  nickname,
  lessonName,
  scheduledDateTime,
  lessonSerialNumber,
  duration
} from "@/utils/getWebserver"
import sensorLog from "@/utils/sensorLog"
export default {
  state: {
    roomDetail: {
      data: {
        roomRole: parseInt(userRole),
        roomId,
        userId,
        nickname,
        lessonName: lessonName,
        scheduleTime: parseInt(scheduledDateTime),
        lessonSerialNumber: lessonSerialNumber,
        duration: parseInt(duration),
        onlineClassId: parseInt(onlineClassId),
        lessonId: parseInt(lessonId)
      },
      status: ""
    },
    enterMediaRoom: {
      data: {},
      status: ""
    },
    enterSignalRoom: {
      data: {},
      status: ""
    },
    exitMedia: "",
    exitSignal: "",
    roomStatus: {
      data: {},
      status: ""
    },
    enterRoomStatus: "",
    isShowModal: false,
    enterRoomParams: null
  },
  actions: {
    async fetchEnterRoomParams({ dispatch, commit, rootState }, payload) {
      commit(types.FETCH_ENTERROOME_PARAMS)
      try {
        commit(
          types.FETCH_ENTERROOME_PARAMS_SUCCESSED,
          await api.fetchEnterRoomParams(payload)
        )
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async updateClassLine({ dispatch, commit, rootState }, payload) {
      commit(types.UPDATA_CLASSROOM_LINE)
      try {
        commit(
          types.UPDATA_CLASSROOM_LINE_SUCCESSED,
          await api.updateClassLine({ roomId, roomType: payload })
        )
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async fetchMediaSDK({ dispatch, commit }, payload) {
      commit(types.FETCH_MEDIA_ENTER_ROME)
      try {
        commit(
          types.FETCH_MEDIA_ENTER_ROME_SUCCESSED,
          await mediaSDK.enterRoom(payload)
        )
      } catch (error) {
        commit(types.FETCH_MEDIA_ENTER_ROME_FAILED)
        return Promise.reject(error)
      }
    },
    async fetchSignalSDK({ state, dispatch, commit }, payload) {
      commit(types.FETCH_SIGNAL_ENTER_ROME)
      try {
        commit(
          types.FETCH_SIGNAL_ENTER_ROME_SUCCESSED,
          await signalSdk.enterRoom(payload)
        )
        dispatch("getSilentUserList")
      } catch (error) {
        commit(types.FETCH_SIGNAL_ENTER_ROME_FAILED)
        return Promise.reject(error)
      }
    },
    async updateRoomStatus({ dispatch, commit, state }, payload) {
      commit(types.UPDATA_ROME_STATUS)
      try {
        commit(
          types.UPDATA_ROME_STATUS_SUCCESSED,
          await api.updateRoomStatus({
            onlineClassId: state.roomDetail.data.onlineClassId
          })
        )
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async exitMediaSDK({ dispatch, commit }, payload) {
      commit(types.EXIT_MEDIA_ROOM_SUCCESSED, await mediaSDK.exitRoom())
    },
    async exitSignalSDK({ dispatch, commit }, payload) {
      commit(types.EXIT_SIGNAL_ROOM_SUCCESSED, await signalSdk.exitRoom())
    }
  },
  mutations: {
    FETCH_ENTERROOME_PARAMS(state, payload) {
      state.enterRoomParams = Object.assign({}, state.enterRoomParams, null)
    },
    FETCH_ENTERROOME_PARAMS_SUCCESSED(state, payload) {
      state.enterRoomParams = { ...payload }
    },
    UPDATA_CLASSROOM_LINE(state, payload) {
      state.classRoomLine = Object.assign({}, state.classRoomLine, {
        data: {},
        status: types.FETCH
      })
    },
    UPDATA_CLASSROOM_LINE_SUCCESSED(state, payload) {
      state.classRoomLine = Object.assign({}, state.classRoomLine, {
        data: { ...payload },
        status: types.FETCH_SUCCESSED
      })
    },
    FETCH_MEDIA_ENTER_ROME(state, payload) {
      state.enterMediaRoom = Object.assign({}, state.enterMediaRoom, {
        data: {},
        status: types.FETCH
      })
      sensorLog.track("openclass_enter_media_room", types.SENSORLOG.type.INIT)
    },
    FETCH_MEDIA_ENTER_ROME_SUCCESSED(state, payload) {
      state.enterMediaRoom = Object.assign({}, state.enterMediaRoom, {
        data: { ...payload },
        status: types.FETCH_SUCCESSED
      })
      sensorLog.track(
        "openclass_enter_media_room",
        types.SENSORLOG.type.SUCCESSED
      )
    },
    FETCH_MEDIA_ENTER_ROME_FAILED(state, payload) {
      sensorLog.track(
        "openclass_enter_media_room",
        types.SENSORLOG.type.FAILED,
        JSON.stringify(payload)
      )
    },
    FETCH_SIGNAL_ENTER_ROME(state, payload) {
      state.enterSignalRoom = Object.assign({}, state.enterSignalRoom, {
        data: {},
        status: types.FETCH
      })
      sensorLog.track("openclass_enter_signal_room", types.SENSORLOG.type.INIT)
    },
    FETCH_SIGNAL_ENTER_ROME_SUCCESSED(state, payload) {
      state.enterSignalRoom = Object.assign({}, state.enterSignalRoom, {
        data: { ...payload },
        status: types.FETCH_SUCCESSED
      })
      sensorLog.track(
        "openclass_enter_signal_room",
        types.SENSORLOG.type.SUCCESSED
      )
    },
    FETCH_SIGNAL_ENTER_ROME_FAILED(state, payload) {
      sensorLog.track(
        "openclass_enter_signal_room",
        types.SENSORLOG.type.FAILED,
        JSON.stringify(payload)
      )
    },
    UPDATA_ROME_STATUS(state, payload) {
      state.roomStatus = Object.assign({}, state.roomStatus, {
        data: {},
        status: types.FETCH
      })
    },
    UPDATA_ROME_STATUS_SUCCESSED(state, payload) {
      state.roomStatus = Object.assign({}, state.roomStatus, {
        data: { ...payload },
        status: types.FETCH_SUCCESSED
      })
    },
    UPDATA_ENTER_ROOM_STATUS(state, payload) {
      state.enterRoomStatus = payload
    },
    UPDATA_ISSHOW_MODAL(state, payload) {
      state.isShowModal = payload
    },
    UPDATA_ALERT_TIPS(state, payload) {
      state.enterAlertTips = payload
    },
    EXIT_MEDIA_ROOM_SUCCESSED(state, payload) {
      state.exitMedia = payload
    },
    EXIT_SIGNAL_ROOM_SUCCESSED(state, payload) {
      state.exitSignal = payload
    }
  },
  getters: {
    enterRoomParams: state => state.enterRoomParams,
    roomDetail: state => state.roomDetail,
    enterMediaRoom: state => state.enterMediaRoom,
    enterSignalRoom: state => state.enterSignalRoom,
    enterRoomStatus: state => state.enterRoomStatus,
    isShowModal: state => state.isShowModal,
    exitMedia: state => state.exitMedia,
    exitSignal: state => state.exitSignal
    // allEnterRoom: state => {
    //   let data1 = state.enterMediaRoom.data
    //   let data2 = state.enterSignalRoom.data
    //   if (
    //     data1.status &&
    //     data1.status === 1 &&
    //     data2.status &&
    //     data2.status === 1
    //   ) {
    //     return { status: 1 }
    //   }
    // }
  }
}
